export default function HeroSection() {
  return (
    <section className="w-full">
      {/* İki Kampanya Banner */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
        {/* Sol Banner - %35 İndirim */}
        <div className="relative overflow-hidden group cursor-pointer">
          <img 
            src="https://tr.puma.com/media/contentmanager/content/hizlikasim_mm35_1536x1536_desktop.jpg"
            alt="Kış Sezonunda 2 ve Üzeri Alışverişte %35 İndirim"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 flex flex-col items-start justify-end p-8 md:p-12">
            <div className="bg-white px-4 py-2 mb-4 text-xs font-bold">
              KIŞ SEZONUNDA HIZLI KASIM
            </div>
            <h2 className="text-white text-4xl md:text-5xl font-bold mb-2">
              2 VE ÜZERİ ALIŞVERİŞTE
            </h2>
            <h2 className="text-white text-4xl md:text-6xl font-bold mb-6">
              %35 İNDİRİM
            </h2>
            <button className="bg-black text-white px-8 py-3 font-bold hover:bg-gray-800 transition whitespace-nowrap cursor-pointer">
              ALIŞVERİŞE BAŞLA
            </button>
          </div>
        </div>

        {/* Sağ Banner - %70 İndirim */}
        <div className="relative overflow-hidden group cursor-pointer">
          <img 
            src="https://tr.puma.com/media/contentmanager/content/hizlikasim_outlet70_1536x1536_desktop.jpg"
            alt="Outlet Ürünlerinde %70'e Varan İndirim"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 flex flex-col items-start justify-end p-8 md:p-12">
            <div className="bg-white px-4 py-2 mb-4 text-xs font-bold">
              OUTLET ÜRÜNLERİNDE FIRSAT
            </div>
            <h2 className="text-white text-4xl md:text-6xl font-bold mb-6">
              %70'e VARAN İNDİRİM
            </h2>
            <button className="bg-black text-white px-8 py-3 font-bold hover:bg-gray-800 transition whitespace-nowrap cursor-pointer">
              ALIŞVERİŞE BAŞLA
            </button>
          </div>
        </div>
      </div>

      {/* H-STREET Banner */}
      <div className="relative w-full overflow-hidden cursor-pointer">
        <img 
          src="https://images.puma.net/images/fn/%7Eregional%7ETUR%7Eothers%7EKOP%7EAW25%7ENovember+Home+Page%7Ehstreetpremium_desktop.jpg"
          alt="H-STREET"
          className="w-full h-auto object-cover"
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          <h2 className="text-white text-5xl md:text-7xl font-bold mb-4">H-STREET</h2>
          <p className="text-white text-xl md:text-2xl mb-8">LEGENDS NEVER DIE</p>
          <button className="bg-black text-white px-8 py-3 font-bold hover:bg-gray-800 transition whitespace-nowrap cursor-pointer">
            ALIŞVERİŞE BAŞLA
          </button>
        </div>
      </div>

      {/* Icons Banner */}
      <div className="w-full">
        <img 
          src="https://images.puma.net/images/fn/%7Eregional%7ETUR%7Eothers%7EKOP%7ESS25%7EMain+page+thin+icons_desktop.jpg/fmt/jpg"
          alt="Ücretsiz Kargo - Bonus Taksit - 60 Gün İade"
          className="w-full h-auto object-cover"
        />
      </div>
    </section>
  );
}
